export enum TagRenamingStrategy {
    GenerateTagNames,
    UseOriginalTags
}